let wakeLock = null;

function cookingModeButtons() {
    const buttons = document.querySelectorAll(".cooking-mode-button");
    return buttons ? buttons : [];
}

async function enableCookingMode() {
    wakeLock = await navigator.wakeLock.request("screen");
    const banner = document.querySelector('.cooking-mode-banner');
    banner.classList.remove('hidden');
}

function disableCookingMode() {
    const banner = document.querySelector('.cooking-mode-banner');

    wakeLock.release().then(() => {
        wakeLock = null;
        banner.classList.add('hidden');
        cookingModeButtons().forEach(button => {
            button.disabled = false;
        });
    }).catch(err => {
        console.log('error releasing cooking mode', err);
    });
}

function enableCookingModeButtons() {
    for (const button of cookingModeButtons()) {
        if ("wakeLock" in navigator) {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                enableCookingMode().then(() => {
                    cookingModeButtons().forEach(button => {
                        button.classList.add('btn-disabled');
                        button.disabled = true;
                    });
                }).catch(err => {
                    console.log('error enabling cooking mode', err);
                });
            });
        } else {
            button.disabled = true;
            const legend = document.querySelectorAll('.cooking-mode-legend');
            legend.forEach(p => {
                p.textContent = "Cooking mode cannot be enabled because only Safari and Chrome support wake lock events";
            });
        }
    }

    const disableCookingModeButton = document.querySelector('#disable-cooking-button');
    disableCookingModeButton.addEventListener('click', (e) => {
        e.preventDefault();
        disableCookingMode();
    });
}

enableCookingModeButtons();
